import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DateInputFillMode, DateInputSize } from '@progress/kendo-angular-dateinputs';
import { CheckBoxRounded } from '@progress/kendo-angular-inputs';
import { isEqual } from 'lodash';
import { SPECIAL_OFFER_CLIENT_STATUS } from 'src/app/extensions/constants/commonConstants';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { PartnerAPIService } from 'src/app/extensions/services/api/partner-api.service';

@Component({
  selector: 'app-special-offer-filter-modal',
  standalone: false,
  templateUrl: './special-offer-filter-modal.component.html',
  styleUrl: './special-offer-filter-modal.component.scss',
})
export class SpecialOfferClientFilterModalComponent implements OnInit {
  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: CheckBoxRounded = 'large';
  public size: DateInputSize = 'large';

  public startDate: Date;
  public endDate: Date;
  private pageFilter: app.models.GetSpecialOffersFilterModel;
  private initialFilterState: app.models.GetSpecialOffersFilterModel;

  types: app.models.DictionaryDataModelWithCheckbox[];
  public statuses: app.models.DictionaryWithCheckbox[];
  dealers: app.models.DictionaryDataModelWithCheckbox[];

  constructor(
    private _activeModal: NgbActiveModal,
    private _translateService: TranslateService,
    private _dictionaryAPIService: DictionaryAPIService,
    private _partnerAPIService: PartnerAPIService
  ) {}

  ngOnInit(): void {
    this._dictionaryAPIService.getDictionaryCampaignTypes().subscribe(res => {
      this.types = res.map(x => ({ ...x, isSelected: this.pageFilter.dictionaryCampaignTypeIds.includes(x.id) }));
    });
    this._partnerAPIService.getDealers().subscribe(res => {
      this.dealers = res.map(x => ({
        id: x.partnerId,
        code: '',
        value: x.name,
        isSelected: this.pageFilter.dealerExternalEntityIds.includes(x.partnerId),
      }));
    });

    this.statuses = [
      {
        name: this._translateService.instant('specialOffers.statusMessage.new'),
        isSelected: this.pageFilter.statuses.some(x => x === SPECIAL_OFFER_CLIENT_STATUS.NEW),
        value: SPECIAL_OFFER_CLIENT_STATUS.NEW,
      },
      {
        name: this._translateService.instant('specialOffers.statusMessage.ongoing'),
        isSelected: this.pageFilter.statuses.some(x => x === SPECIAL_OFFER_CLIENT_STATUS.ONGOING),
        value: SPECIAL_OFFER_CLIENT_STATUS.ONGOING,
      },
      {
        name: this._translateService.instant('specialOffers.statusMessage.ending_soon'),
        isSelected: this.pageFilter.statuses.some(x => x === SPECIAL_OFFER_CLIENT_STATUS.ENDING),
        value: SPECIAL_OFFER_CLIENT_STATUS.ENDING,
      },
      {
        name: this._translateService.instant('specialOffers.statusMessage.upcoming'),
        isSelected: this.pageFilter.statuses.some(x => x === SPECIAL_OFFER_CLIENT_STATUS.UPCOMING),
        value: SPECIAL_OFFER_CLIENT_STATUS.UPCOMING,
      },
    ];
  }

  disableStartDates = (date: Date): boolean => {
    if (this.pageFilter.toDate) {
      return date > this.pageFilter.toDate;
    }
    return false;
  };

  disableEndDates = (date: Date): boolean => {
    if (this.pageFilter.fromDate) {
      return date < this.pageFilter.fromDate;
    }
    return false;
  };

  closeHandler() {
    this._activeModal.close(false);
  }

  applyHandler() {
    if (this.startDate) this.pageFilter.fromDate = this.startDate;
    if (this.endDate) this.pageFilter.toDate = this.endDate;
    this.pageFilter.dealerExternalEntityIds = this.dealers.filter(x => x.isSelected).map(x => x.id);
    this.pageFilter.dictionaryCampaignTypeIds = this.types.filter(x => x.isSelected).map(x => x.id);
    this.pageFilter.statuses = this.statuses.filter(x => x.isSelected).map(x => x.value);
    let count = 0;
    if (this.pageFilter.fromDate != null) count++;
    if (this.pageFilter.toDate != null) count++;
    if (this.pageFilter.dealerExternalEntityIds) count = count + this.pageFilter.dealerExternalEntityIds.length;
    if (this.pageFilter.dictionaryCampaignTypeIds) count = count + this.pageFilter.dictionaryCampaignTypeIds.length;
    if (this.pageFilter.statuses) count = count + this.pageFilter.statuses.length;
    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : count);
  }

  resetHandler() {
    this.pageFilter.fromDate = null;
    this.pageFilter.toDate = null;
    this.pageFilter.dictionaryCampaignTypeIds = [];
    this.pageFilter.dealerExternalEntityIds = [];
    this.pageFilter.statuses = [];
    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : 0);
  }
}
